import styled from '@emotion/styled'
import { Container } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import { Link } from 'react-router-dom'

export const FooterContainer = styled(Container)`
  label: FooterContainer;
  color: ${(props) => props.theme.colors.footerText};
  font-size: 16px;
  strong {
    color: ${(props) => props.theme.colors.navColor};
  }
  .col-sm-8 h5 + p {
    max-width: 490px;
  }
`
export const FooterLogoContainer = styled('div')`
  label: FooterLogoContainer;
  margin-bottom: 3rem;
  justify-content: center;
  display: flex;
`
export const FooterPrimaryButton = styled(PrimaryButton)`
  label: FooterPrimaryButton;
  font-size: 16px !important;
  font-weight: 700 !important;
  padding: 11px 24px !important;

`
export const FooterLinks = styled('a')`
  label: FooterLinks;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 16px;
  margin-bottom: 0.6rem;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
  text-decoration: none;
  display: block !important;
  :hover {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`

export const FooterHeadings = styled.p`
  label: FooterHeadings;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-weight: 700 !important;
  margin-bottom: 0;
`

export const FooterText = styled.p`
  label: FooterText;
  color: ${(props) => props.theme.colors.textLightblack};
  font-weight: normal;
  margin-bottom: 18px;
`

export const FooterDomLinks = styled(Link)`
  label: FooterDomLinks;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 16px;
  margin-bottom: 0.6rem;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
  text-decoration: none;
  display: block !important;
  :hover {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`
export const FooterSocialLinks = styled('a')`
  label: FooterSocialLinks;
  margin-right: 30px;
`

export const FooterHr = styled('hr')`
  label: FooterHr;
  border-color: rgba(0, 0, 0, 0.2);
  border-width: 1px;
  margin-top: 0;
  margin-bottom: 2rem;
`
